export const sharedObjects = {
  navData: [
    { name: "Home", route: "/" },
    { name: "Shop", route: "/shop" },
    { name: "Pages", route: "/" },
    { name: "Contact", route: "/contact" },
  ],
  logoText: "Lebaba",
  bannerText: {
    discountText: "up to 20% discount on",
    fashionText: "Girls's Fashion",
    bannerText: `Discover the latest trends and express your unique style with our
          women's Fashion website. Explore a curated collection of clothing,
          accessories, and footwear that caters to every taste and occasion.`,
    explore: "explore now",
  },
  TrendingProducts: {
    text: "Discover the Hottest Picks: Elevate Your Style with Our Curated Collection of Trending Women;s Fashion Products",
  },
  DealSection: {
    h5: `Get Up to 20% Discount`,
    h4: `Deals Of This Month`,
    paraText: `Our Women's Fashion Deals of the Month are here to make your style
          dreams a reality without breaking the bank. Discover a curated
          collection of exquisite clothing, accessories, and footwear, all
          handpicked to elevate your wardrobe.`,
  },
  PromoBannerText: {
    deliveryText: "Free Delivery",
    offers:
      "Offers convenience and the ability to shop from anywhere, anytime.",
    moneyBackText: "100% Money Back Guaranty",
    reviewText:
      "E-Commerce have a review system where customers can share feedbacks.",
  },
  BlogsText: {
    latestText: "Latest From Blogs",
    WardRobe:
      "Elevate your wardrobe with our freshest style tips, trends, and inspiration on our blogs.",
  },
  categoryPage: {
    subHeader:
      "Browse a diverse range of categories, from chic dresses to versatile accessories. Elevate your style today!",
    search: "Search Page",
    searchText: "Search",
  },
  shopFiltering: {
    filtersText: "Filters",
    category: "Category",
    colorsText: "Color",
  },
};

export default sharedObjects;
